import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import ModalButtons from '../../components/Modal/ModalButtons';

// Provider / company-admin editor for which alert categories a user is emailed.
const AlertPrefsModal = ({ data }) => {
	const {
		alertPrefsModalStatus,     // { status, username }
		alertPrefsCategories,      // [{ key, label }]
		alertPrefsSelected,        // array of selected keys
		alertPrefsLoading,
		toggleAlertPref,
		closeAlertPrefsModal,
		handleSaveAlertPrefs,
	} = data;

	const selected = alertPrefsSelected || [];

	return (
		<Modal show={alertPrefsModalStatus.status}>
			<ModalHeading
				heading={`Alert Emails${alertPrefsModalStatus.username ? ' — ' + alertPrefsModalStatus.username : ''}`}
				subHeading=''
			/>
			<ModalForm>
				<p style={{ margin: '0 0 12px', fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>
					Choose which alert categories this user is emailed about. Emails also
					require the global email switch to be on (Settings page).
				</p>
				{alertPrefsLoading ? (
					<p style={{ fontSize: 13, color: '#64748b' }}>Loading…</p>
				) : (
					<div style={{ display: 'flex', flexDirection: 'column', gap: 10, margin: '4px 0 8px' }}>
						{(alertPrefsCategories || []).map((cat) => {
							const on = selected.includes(cat.key);
							return (
								<label
									key={cat.key}
									style={{
										display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer',
										padding: '8px 10px', borderRadius: 6,
										border: '1px solid #e2e8f0',
										background: on ? 'rgba(162,0,0,0.05)' : 'transparent',
									}}
								>
									<input
										type='checkbox'
										checked={on}
										onChange={() => toggleAlertPref(cat.key)}
										style={{ width: 16, height: 16, accentColor: '#a20000' }}
									/>
									<span style={{ fontSize: 14 }}>{cat.label}</span>
								</label>
							);
						})}
					</div>
				)}
				<ModalButtons
					submitButtonLabel='Save'
					onSubmit={handleSaveAlertPrefs}
					cancelButtonLabel='Cancel'
					onCancel={closeAlertPrefsModal}
				/>
			</ModalForm>
		</Modal>
	);
};

export default AlertPrefsModal;
